/* eslint-disable react/prop-types */
// react-quill components
import ReactQuill from "react-quill";

import { useLocation, useParams } from "react-router-dom";

// react-quill styles
import "react-quill/dist/quill.snow.css";

// Custom styles for the SoftEditor
import SoftEditorRoot from "components/SoftEditor/SoftEditorRoot";

function SoftEditor(props) {
  const { id } = useParams();
  const location = useLocation();
  const containEdit = location.pathname?.includes("/edit");
  const disabled = id && !containEdit;
  return (
    <SoftEditorRoot>
      <ReactQuill readOnly={disabled} preserveWhitespace theme="snow" {...props} />
    </SoftEditorRoot>
  );
}

export default SoftEditor;
